import React from 'react';
import './forms.css';

const MachinerySup = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSdhG0KF_dDQJJu9CN1vzzdVZqvLsQf_g1MelYLZMC2zPIb1kg/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default MachinerySup;